export class ObterConteudoCadernoIdInputDto{
  id: number;

  constructor(id: number) {
    this.id = id;
  }
}